<app-in-app-page>
  <app-header title="View fax"></app-header>

  <main class="faxes">
    <div>
      <h2 class="faxes-title">View documents</h2>

      <div class="paper faxes-section faxes-info-section">
        <p class="faxes-info-item">
          Message #: <span class="faxes-info-item__value">{{ fax?.id }}</span>
        </p>

        <p class="faxes-info-item">
          From: <span class="faxes-info-item__value">{{ fax?.fromNumber }}</span>
        </p>

        <p class="faxes-info-item">
          To: <span class="faxes-info-item__value">{{ fax?.toNumber }}</span>
        </p>

        <div class="faxes-info-item faxes-id-item">
          Delivery ID:
          <span class="faxes-info-item__value faxes-id">{{ fax?.id }}</span>
        </div>

        <p class="faxes-info-item">
          Fax Date: <span class="faxes-info-item__value">{{ formatFaxDate(fax?.createdAt) }}</span>
        </p>

        <p class="faxes-info-item">
          Page Count: <span class="faxes-info-item__value">{{ fax?.pages }}</span>
        </p>

        <p class="faxes-info-item">
          Fax Status:
          <span class="faxes-info-item__value faxes-status">{{ fax?.status }}</span>
        </p>
      </div>

      <div class="faxes-section paper">
        <h2 class="faxes-section-title">Preview</h2>

        <div class="faxes-pages-preview">
          <app-fax-pages-previews
            [src]="faxFileSrc"
            [columns]="4"
            (selectPage)="selectFaxFilePage($event)"
          ></app-fax-pages-previews>
        </div>
      </div>
    </div>

    <div>
      <app-fax-pdf-viewer
        [faxId]="fax?.id"
        [faxFileSrc]="faxFileSrc"
        [faxFilePage]="faxFilePage"
        [faxStatus]="fax?.status"
        (resendClick)="sendFax()"
        (fullscreenClick)="isZoomModalOpen = true"
        (openDetailedInfoClick)="isInfoModalOpen = true"
        (deleteClick)="openDeleteConfirmationPopup()"
        (emailClick)="openEmailModal()"
      ></app-fax-pdf-viewer>
    </div>
  </main>

  <app-fax-info-modal [isOpen]="isInfoModalOpen" [fax]="fax" (close)="isInfoModalOpen = false"></app-fax-info-modal>

  <app-fax-zoom-modal
    [isOpen]="isZoomModalOpen"
    [faxFileSrc]="faxFileSrc"
    [faxFilePage]="faxFilePage"
    (close)="isZoomModalOpen = false"
  ></app-fax-zoom-modal>

  <app-delete-fax-modal (submit)="deleteFax()"></app-delete-fax-modal>

  <app-resend-fax-modal
    [fax]="faxToResend"
    [initialTab]="'Email'"
    (submit)="onResendModalSubmit()"
  ></app-resend-fax-modal>
</app-in-app-page>
